export class PessoaContaBancaria {
    idPessoa : number;
    idTipoConta : number;
    nrBanco : string;
    nrAgBanco : string;
    nrContaBanco : string;
    icPadrao : string;
    icAtivo : string;
}